import { Box, BoxProps } from '@chakra-ui/react'

const OverlayAction: React.FC<
  { children: React.ReactNode | React.ReactNode[] } & BoxProps
> = ({ children, ...props }) => (
  <Box
    justifyContent="center"
    alignItems="center"
    borderRadius="full"
    px={2}
    gap={2}
    bg="white"
    color="onyx"
    className="body-small-emphasis"
    {...props}
  >
    {children}
  </Box>
)

export default OverlayAction
